import React from 'react';

import TopBar from './topBar.svg';

const MallGuideTopBar = ({ classes }) => (
  <div>
    <div className={classes.topBarContainer}>
      <TopBar />
    </div>
  </div>
);

MallGuideTopBar.propTypes = {};

export default MallGuideTopBar;
